import { assignJob, getFreePopulation, MAX_LUMBERJACKS } from '../map/settlement';
import type { ModalActionHandler } from './modalActionTypes';
import { getSettlement } from './settlementActionUtils';

export const hireLumberjackAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement || settlement.buildings.lumberjack.qty <= 0) return false;
    const freePop = getFreePopulation(settlement);
    const cap = MAX_LUMBERJACKS * settlement.buildings.lumberjack.qty;
    if (settlement.jobs.lumberjacks >= cap || freePop <= 0) return false;
    if (!assignJob(settlement, 'lumberjacks')) return false;
    return true;
};
